import React from "react";

import { authInterceptor } from "../services/axios/interceptor";

function Dropdown({plan, assistance, statusStyle, setStatusStyle, getStatusStyle, onOpenModal}) {
  
  // Si el estado de la asistencia es null o falso (no ha informado que asistirá o cancelo asistencia)
  // El botón de acción debe decir Attend (Asistir)
  const [confirmAssistance, setConfirmAssistance] = React.useState(statusStyle === 'primary' || statusStyle === 'success');
  const [messageAssistance, setMessageAssistance] = React.useState(statusStyle === 'primary' || statusStyle === 'secondary');

  const handleAction = () => {
    // Si no ha informado que asistirá se debe crear la asistencia
    if(statusStyle === 'primary'){
      createAssistance();
    } else {
      updateAssistance();
    }
  }

  const createAssistance = () => {
    var data = JSON.stringify({
      "plan": plan,
      "status": true
    });
    
    authInterceptor.post('/api/operations/planning_assistance/', data)
    .then(function (response) {
      console.log(JSON.stringify(response.data));
      assistance.id = response.data.id
      setConfirmAssistance(response.data.status);
      setStatusStyle(getStatusStyle(confirmAssistance));
      setMessageAssistance(!response.data.status);
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  const updateAssistance = () => {
    var data = JSON.stringify({
      "plan": plan,
      "status": !confirmAssistance
    });
    
    authInterceptor.patch(`/api/operations/planning_assistance/${assistance.id}/`, data)
    .then(function (response) {
      console.log(JSON.stringify(response.data));
      setConfirmAssistance(response.data.status);
      setStatusStyle(getStatusStyle(response.data.status));
      setMessageAssistance(!response.data.status);
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  return (
    <div className="dropdown">
      <button
        className={`btn btn-${statusStyle} dropdown-toggle`}
        type="button"
        id="dropdownMenuIconButton6"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i className="mdi mdi-dots-vertical"></i>
      </button>
      <div className="dropdown-menu" aria-labelledby="dropdownMenuIconButton6">
        <button className="dropdown-item" onClick={handleAction}>
          {messageAssistance ? 'Attend' : 'Cancel'}
        </button>
        <button
          className="dropdown-item"
          data-toggle="modal"
          data-target="#exampleModal"
          onClick={() => onOpenModal(plan)}
        >
          Details
        </button>
      </div>
    </div>
  );
}

export { Dropdown };
